module.exports = __webpack_public_path__ + "media/images/web/landings/students/s8-226c8c8a025e60d0a0a3b8b213ac61b1.jpg";